module.exports = __webpack_public_path__ + "img/img_ms.88688eef.png";